// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3kdrp","text":"styles_text__QawOp","more-competences":"styles_more-competences__ANRdJ"};